import React, { Component } from 'react';
import { Field, reduxForm, change } from 'redux-form';
import LeftArrow from 'mdi-react/ArrowLeftIcon';
import { withRouter } from 'react-router-dom';
import { render_field } from '../../../../utils/renderField';
import { role_list, pilot_packages } from '../../../../utils/mock_data';
import AWS from 'aws-sdk';

const s3 = new AWS.S3({ accessKeyId: process.env.REACT_APP_ACCESS_KEY, secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY, region: process.env.REACT_APP_REGION });

class Finalize extends Component {
  state = {
    uploadError: null
  }

  componentDidMount() {
    const { password, telephone, role, pilot } = this.props.fields;
    this.props.dispatch(change('finalizeForm', 'password', password));
    this.props.dispatch(change('finalizeForm', 'telephone', telephone));
    this.props.dispatch(change('finalizeForm', 'role', role));
    this.props.dispatch(change('finalizeForm', 'package', pilot));
  }

  onSubmit() {
    const fields = this.props.fields;
    delete fields.password

    s3.upload({ Body: JSON.stringify(fields), Bucket: process.env.REACT_APP_BUCKET_NAME, Key: `${fields.company_name}-${new Date().getTime()}.json` }, (err, data) => {
      if (err) {
        console.log(err)
        console.log('show error ui')
        this.setState({ uploadError: 'An unexpected Error Occured.\nPlease try again in a few minutes.' })
      }
      else {
        this.setState({ uploadError: null })
        this.props.history.push('/confirmation');
      }
    })
  }

  render() {
    const { password, telephone, role, pilot } = this.props.fields;

    const { handleSubmit } = this.props;

    return (
      <form className='form' onSubmit={handleSubmit(this.onSubmit.bind(this))}>
        <div>
          <img src="../img/avatar.png" className='account__avatar' alt="Account Avatar"/>
          <h3 className='formHeader'>Create Your Account</h3>
          <p className='description'>Add a password to save your new Posture Account!</p>
        </div>

        <div className='form__form-group'>
          <p style={{ color: '#F00', fontSize: 14 }}>{this.state.uploadError ? this.state.uploadError : ''}</p>
          <div className='form__form-group-field'>
            <Field
              id='password'
              name='password'
              value={password}
              component={render_field}
              type='password'
              placeholder='Password'
              onChange={this.props.handleChange}
              defaultValue={password}
            />
          </div>

          <div className='form__form-group-field'>
            <Field
              id='telephone'
              name='telephone'
              value={telephone}
              component={render_field}
              type='text'
              placeholder='Telephone'
              onChange={this.props.handleChange}
              defaultValue={telephone}
            />
          </div>

          <div className='form__form-group-field'>
            <Field
              id='role'
              name='role'
              component={render_field}
              fontFamily='Lato'
              type='select'
              placeholder='Role'
              options={role_list}
              defaultValue={role === '' ? role_list[0] : role}
              onChange={role => {
                this.props.changeSelect('role', role)
              }}
            />
          </div>

          <div className='form__form-group-field'>
            <Field
              id='package'
              name='package'
              component={render_field}
              fontFamily='Lato'
              type='select'
              placeholder='Package'
              options={pilot_packages}
              defaultValue={pilot === '' ? pilot_packages[0] : pilot}
              onChange={pkg => {
                this.props.changeSelect('pilot', pkg)
              }}
            />
          </div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          alignContent: 'center',
          width: '60%'
        }}>
          <span className='finalized-arrow'>
            <LeftArrow
              style={{ fill: '#AEB8C4', verticalAlign: 'middle' }}
              onClick={() => { this.props.back() }}
            />
          </span>
          <button className='onBoardingBtn'>Done: Create Environment!</button>
        </div>
      </form>
    )
  }
}

function validate(values) {
  let errors = {};

  if (!values.telephone) {
    errors.telephone = "Enter your telephone number";
  }

  if (!values.password || values.password.length < 5) {
    errors.password = "Enter your password";
  }

  if (!values.role) {
    errors.role = "Select Role";
  }

  if (!values.package) {
    errors.package = "Select Package";
  }

  return errors;
}

export default withRouter(reduxForm({
  form: "finalizeForm",
  validate
})(Finalize));


// WEBPACK FOOTER //
// ./src/pages/account/register/components/finalize.js